// src/utils/rateLimiter.ts

interface RateLimitEntry {
  count: number;
  firstAttempt: number;
}

const rateLimiter = new Map<string, RateLimitEntry>();

export const checkRateLimit = (
  identifier: string,
  limit: number,
  windowMs: number
): boolean => {
  const now = Date.now();
  const entry = rateLimiter.get(identifier);

  if (!entry) {
    rateLimiter.set(identifier, { count: 1, firstAttempt: now });
    return true;
  }

  if (now - entry.firstAttempt > windowMs) {
    rateLimiter.set(identifier, { count: 1, firstAttempt: now });
    return true;
  }

  if (entry.count >= limit) {
    return false;
  }

  entry.count++;
  rateLimiter.set(identifier, entry);
  return true;
};
